import React from "react";
import { Link } from "react-router-dom";
import "./ServicePages.css";
import Seo from "../components/Seo";

const AboutPage = () => {
  return (
    <div className="page-shell" data-theme="about">
      <Seo
        title="About J3 Innovations | Kingwood & Houston Painters"
        description="Learn about J3 Innovations, a father–son painting and construction team serving Kingwood and Houston with prep-first systems."
        canonicalPath="/about"
        image="/logo192.png"
      />
      <div className="page-wrap">
        <div className="page-hero">
          <p className="page-eyebrow">About</p>
          <h1>J3 Innovations</h1>
          <p className="lead">
            Family-run painting and wall-systems crew. Calm, confident, professional —
            and a little luxurious while staying blue-collar real.
          </p>
          <div className="pill-row">
            <span className="pill">Houses aren’t hobbies</span>
            <span className="pill">Anti DIY hacks</span>
            <span className="pill">Respect the house, the craft, the weekend</span>
          </div>
        </div>

        <div className="section-block">
          <h2>What we believe</h2>
          <p>
            Home maintenance is not a weekend project — it is infrastructure. We turn serious
            trade knowledge into productized wall systems that protect a home, its value, and
            the owner’s time.
          </p>
        </div>

        <div className="section-block">
          <h2>How we work</h2>
          <div className="bullet-grid">
            <div className="bullet-card">
              <h3>Systems, not hours</h3>
              <ul>
                <li>Clear SKUs, clear scope, no bait-and-switch estimates.</li>
                <li>Repeatable processes that keep quality high every time.</li>
              </ul>
            </div>
            <div className="bullet-card">
              <h3>Prep-first mindset</h3>
              <ul>
                <li>Straight, smooth, skim-coated walls before the first brush moves.</li>
                <li>Masking-film stencils and caulked edges for precise graphics.</li>
              </ul>
            </div>
            <div className="bullet-card">
              <h3>Respect for your weekend</h3>
              <ul>
                <li>We show up ready, minimize downtime, and leave clean.</li>
                <li>Trade-grade materials matched to the room and climate.</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="section-block">
          <h2>Where we’re headed</h2>
          <p>
            We’re investing in stencil-driven murals, 3D-printed relief patterns, and
            integrated textured trim systems that make old-school approaches obsolete. Early
            clients of J3 Interior Decals and J3 Fast Flash get first access to the Texture Lab.
          </p>
          <Link to="/quote" className="cta-inline">
            Get on the list →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
